module.exports = __webpack_public_path__ + "img/3a56586.png";